import React from 'react';
import { makeStyles, Typography, Box } from '@material-ui/core';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import Typography500 from 'common/components/Typography500';

const useStyles = makeStyles((theme) => ({
  ABicon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.primary.dark,
  },
  ABTitle: {
    fontSize: theme.typography.pxToRem(13),
    lineHeight: theme.typography.pxToRem(16),
    color: theme.palette.primary.dark,
  },
  ABDetails: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.grey['400'],
    lineHeight: '1.25rem',
  },
}));

const AnnouncementBar = (props) => {
  const classes = useStyles();
  const { title, description } = props;

  return (
    <Box display="flex">
      <WhatshotIcon className={classes.ABicon} />
      <Box>
        <Typography500 className={classes.ABTitle}>
          {title}
        </Typography500>

        {description.map((desc) => (
          <Typography key={desc} className={classes.ABDetails}>
            {desc}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default AnnouncementBar;
